export default function<T extends Date | number>(value?: T | null) {
  if (value === null || value === undefined) {
    return undefined
  }

  return { lte: value }
}
